// src/components/Loader.jsx
import React from "react";
import Lottie from "lottie-react";
import animationData from "../assets/animations/CarInCity.json"; // adjust path

export default function Loader() {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-full bg-gradient-to-br from-blue-50 via-white to-violet-50">
      {/* Animation */}
      <Lottie
        animationData={animationData}
        loop={true}
        className="w-40 h-40 sm:w-56 sm:h-56 md:w-72 md:h-72 lg:w-80 lg:h-80 animate-fadeIn"
      />

      {/* Text below loader */}
      <p className="mt-6 text-sm sm:text-base md:text-lg font-medium text-gray-600 animate-pulse">
        Loading ...
      </p>
    </div>
  );
}
